/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, PanelRow, SelectControl, CheckboxControl, TextControl } from '@wordpress/components';
import { Fragment, useEffect } from '@wordpress/element';
import $ from 'jquery';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

function preview_block(args, blockId){
    var data = {
        action : 'oer_display_resource_block',
        params: args,
    };
   $.ajax({ 
        url: oer_resource.ajaxurl, 
        type: 'POST',
        data: data,
        success:function(response){
            $('#block-' + blockId + ' .wp-block-wp-oer-plugin-wp-oer-resource-block').html("");
            $('#block-' + blockId + ' .wp-block-wp-oer-plugin-wp-oer-resource-block').html(response);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown){
            console.log(errorThrown);
        }
    })
}

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit(props) {
    var display = __("Loading...","wp-oer-resource-block");
    var resourceOptions;
    var optionResources = [{ label:__( 'Select a resource' , 'wp-oer-resource-block' ), value:'' }];
    var showThumbnail = false;
    var showTitle = false;
    var showDescription = false;
    var showSubjects = false;
    var showGradeLevels = false;
    var wBorder = false;

    const { attributes, setAttributes, className, clientId } = props;

    const alignmentOptions = [
                            { label:__('Select Alignment','wp-oer-resource-block') , value: '' },
                            { label:__('Left','wp-oer-resource-block') , value: 'left' },
                            { label:__('Center','wp-oer-resource-block') , value: 'center' },
                            { label:__('Right','wp-oer-resource-block') , value: 'right' }
                            ];

    // get all resources
    const getResources = () => {
        if (oer_resource.perm_structure){
            wp.apiFetch( { url:oer_resource.home_url  + '/wp-json/oer-resource-block/v1/resources'} ).then( resources => {
                setAttributes( { resources: resources } );
            });
        } else {
            wp.apiFetch( { url:oer_resource.home_url  + '?rest_route=/oer-resource-block/v1/resources'} ).then( resources => {
                setAttributes( { resources: resources } );
            });
        }
    }

    useEffect(() => {
        getResources();
    },[]);
    
    if (typeof attributes.resources !== 'undefined'){
        if  (attributes.resources.length>0)
            display = __('There are ','wp-oer-resource-block')+ attributes.resources.length + __(' resources to choose from. Please select one.','wp-oer-resource-block');

        let resources = (attributes.resources.map((resource) => {
            return { label: resource.title, value: resource.id }
        }));
        optionResources = optionResources.concat(resources);
    } 

    const onChangeResource = ( newResource ) => {
        setAttributes( { selectedResource: parseInt(newResource), isChanged: true } );
    }

    const onChangeAlignment = ( newAlignment ) => {
        setAttributes( { alignment: newAlignment, isChanged: true } );
    }

    const onChangeWidth = ( newWidth ) => {
        setAttributes( { blockWidth:newWidth, isChanged: true } );
    }

    const onShowThumbnail = ( checked ) => {
        setAttributes( { showThumbnail: checked, isChanged: true } );
    }

    const onShowTitle = ( checked ) => {
        setAttributes( { showTitle: checked, isChanged: true } );
    }

    const onShowDescription = ( checked ) => {
        setAttributes( { showDescription: checked, isChanged: true } );
    }

    const onShowSubjects = ( checked ) => {
        setAttributes( { showSubjects: checked, isChanged: true } );
    }

    const onShowGradeLevels  = ( checked ) => {
        setAttributes( { showGrades: checked, isChanged: true } );
    }

    const onWithBorder = ( checked ) => {
        setAttributes( { withBorder: checked, isChanged: true } );
    }

    const setBlockId = (blockId) =>  { setAttributes( { blockId } ); }

    if( clientId !== attributes.blockId ){
        setBlockId(clientId);
    }

    if (typeof attributes.selectedResource !== 'undefined'){
        preview_block(attributes, attributes.blockId);
    }

	return [(
        <Fragment>
            <InspectorControls className={ className }>
                <PanelBody
                    title={ __('OER Resource Options','wp-oer-resource-block') }
                    initialOpen>
                    <PanelRow>
                        <SelectControl
                            className = { 'oer-resource-block-resource-field' }
                            label = { __('Resource','wp-oer-resource-block') }
                            value = { attributes.selectedResource }
                            options = { optionResources }
                            onChange = { onChangeResource }
                            />
                    </PanelRow>
                    <PanelRow>
                        <SelectControl
                            className = { 'oer-resource-block-alignment-field' }
                            label = { __('Alignment','wp-oer-resource-block') }
                            value = { attributes.alignment }
                            options = { alignmentOptions }
                            onChange = { onChangeAlignment }
                            />
                    </PanelRow>
                    <PanelRow>
                        <TextControl
                            className = { 'oer-resource-block-width-field' }
                            label = { __( 'Width in pixels(optional)' , 'wp-oer-resource-block' ) }
                            value = { attributes.blockWidth }
                            onChange = { onChangeWidth }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-thumbnail' }
                            label = { __( 'Show thumbnail' , 'wp-oer-resource-block' ) }
                            checked = { attributes.showThumbnail }
                            onChange = { onShowThumbnail }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-title' }
                            label = { __( 'Show title' , 'wp-oer-resource-block' ) }
                            checked = { attributes.showTitle }
                            onChange = { onShowTitle }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-description' }
                            label = { __( 'Show description' , 'wp-oer-resource-block' ) }
                            checked = { attributes.showDescription }
                            onChange = { onShowDescription }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-subjects' }
                            label = { __( 'Show subjects' , 'wp-oer-resource-block' ) }
                            checked = { attributes.showSubjects }
                            onChange = { onShowSubjects }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-grade-levels' }
                            label = { __( 'Show grade levels' , 'wp-oer-resource-block' ) }
                            checked = { attributes.showGrades }
                            onChange = { onShowGradeLevels }
                        />
                    </PanelRow>
                    <PanelRow>
                        <CheckboxControl
                            className = { 'oer-resource-block-show-with-border' }
                            label = { __( 'Show block with border' , 'wp-oer-resource-block' ) }
                            checked = { attributes.withBorder }
                            onChange = { onWithBorder }
                        />
                    </PanelRow>
                </PanelBody>
            </InspectorControls>
        </Fragment>
        ),
        <div { ...useBlockProps() }>
            <div className={ "wp-block-wp-oer-plugin-wp-oer-resource-block" }>{ display }</div>
        </div>
    ];
}
